import { useEffect, useState } from 'react';

export const useBase64FromUrl = (url: string) => {
  const [base64Content, setBase64Content] = useState<string>();

  const toBase64FromUrl = (url: string) => {
    const xhr = new XMLHttpRequest();
    xhr.onload = () => {
      const reader = new FileReader();
      reader.onloadend = () => {
        setBase64Content(reader.result as string);
      };
      reader.readAsDataURL(xhr.response);
    };
    xhr.open('GET', url);
    xhr.responseType = 'blob';
    xhr.send();
  };

  useEffect(() => {
    if (base64Content == null) {
      toBase64FromUrl(url);
    }
  }, []);

  return { base64Content };
};
